import component from "./Schedule";

export default component;
